import { render } from "./associationEdit.vue?vue&type=template&id=54a0b876&scoped=true"
import script from "./associationEdit.vue?vue&type=script&lang=js"
export * from "./associationEdit.vue?vue&type=script&lang=js"

import "./associationEdit.vue?vue&type=style&index=0&id=54a0b876&lang=scss&scoped=true"
import "./associationEdit.vue?vue&type=style&index=1&id=54a0b876&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a0b876"]])

export default __exports__